<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar ref="nav" :placeholder="true" :fixed="true" title="巡检列表" left-text="返回" left-arrow @click-left="goBack">
				<template #right>
					<van-icon v-if="showAdd" size="26" name="add-o" @click="toAdd"/>
				</template>
			</van-nav-bar>
		</div>
		<van-sticky :offset-top="navbarHeight">
			<van-row gutter="20">
				<van-col span="3" style="padding-right: 0;">
					<div class="div_icon">
						<van-icon name="bars" size="30" @click="showStatusPicker = true" style="vertical-align:middle" />
					</div>
				</van-col>
				<van-col span="21" style="padding-left: 0;">
					<form action="/">
						<van-search
							v-model="queryParam.keyWord"
							shape="round"						
							placeholder="请输入搜索关键词"
							:clearable="true"
							@search="onRefresh"
							@clear="onClear"
						/>
					</form>
				</van-col>
			</van-row>
		</van-sticky>
		
		<van-popup v-model="showStatusPicker" position="bottom">
			<van-picker show-toolbar :columns="statusList" value-key="name" @confirm="selStatusPicker" @cancel="showStatusPicker = false" />
		</van-popup>
		<!-- 下拉刷洗 -->
		<van-pull-refresh v-model="isRefreshLoading" success-text="刷新成功" @refresh="onRefresh">
			<van-list
				v-model="loading"
				:finished="finished"
				finished-text="没有更多了"
				:error.sync="error"
				error-text="请求失败，点击重新加载"
				@load="loadMore"
			>
				<div class="patrolList" :class="{
					isBgBluish2: item.stateFlg === '1'}" 
					v-for="item in dataList" :key="item.inspectionId" @click="goDetail(item.inspectionId)">
					<van-row gutter="10" class="notesTop">
						<van-col span="6">
							<div class="patrolLabel isBgDarkOrange">{{item.majorName}}</div>
							<div class="patrolLabel isBgBlue">{{item.categoryName}}</div>
						</van-col>
						<van-col span="18">
							<div class="patrolTitle">{{item.subjectName}}</div>
						</van-col>
					</van-row>
					<div class="patrolDesc">{{item.inspectionContent}}</div>
					<div class="patrolTime">{{item.inspectionTime | formatDate('yyyy-MM-dd')}} {{item.inspectionMan}}</div>
					<div class="patrolDesc">{{item.sutContent}}</div>
					<div class="patrolTime">
						<!-- {{item.problem.poseTime}} {{item.problem.poseMan}} -->
						<van-button v-if="showEdit" type="info" class="darkEqWidthBtn" size="small" @click.stop="goEdit(item.inspectionId)">编辑</van-button>
						<!-- <van-button v-if="item.closeState == '0' && showClose" type="info" class="darkEqWidthBtn" size="small" @click.stop="goClose(item.inspectionId)">封闭</van-button>
						<span v-if="item.closeState === '1'" class="isClosed">已封闭</span> -->
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
	import { list } from '../../api/qualityPatrol'
	import common from '../../utils/common';

	export default {
		name: 'qualityPatrolList',
		data() {
			return {
				isRefreshLoading: false,
				error: false,
				loading: false,
				finished: false,
				dataList: [],
				// 项目名称
				projectName: '',
				// 查询传递对象
				queryParam: {
					page: 0,
					limit: 10,
					workNo: null,
					// PC端传值category=1，范畴：质量=1；安全=2；进度=3
					category: 1,
					// 搜索框内容
					keyWord: null,
					// 记录状态：0，未封闭；
					closeState: null,
				},
				showAdd: false,
				showEdit: false,
				showClose: true,
				showStatusPicker: false,
				statusList: [
					{id: 0,name:"未封闭"},
					{id: "", name:"全部"}
				],
				navbarHeight:0,
			}
		},
		mounted() {
			this.navbarHeight = this.$refs.nav.height;//吸顶的距离
			this.project = common.getProject();
			if(this.project == null || this.project == undefined){
				Notify({ type: 'danger', message: '获取项目信息失败' });
			}
			this.queryParam.workNo = this.project.workNo;
			this.projectName = this.project.projectName;
			if (common.hasPermision("patrol:add:1")) {
				this.showAdd = true;
			}
			if (common.hasPermision("patrol:edit:1")) {
				this.showEdit = true;
			}
		},
		filters : {
			formatDate: function (value, args) {
				if (!value) {
					return ''
				}
				var dt = new Date(value);
				if (args == 'yyyy-M-d') {// yyyy-M-d
					let year = dt.getFullYear();
					let month = dt.getMonth() + 1;
					let date = dt.getDate();
					return `${year}-${month}-${date}`;
				} else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
					let year = dt.getFullYear();
					let month = dt.getMonth() + 1;
					let date = dt.getDate();
					let hour = dt.getHours();
					let minute = dt.getMinutes();
					let second = dt.getSeconds();
					return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
				} else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
					let year = dt.getFullYear();
					let month = (dt.getMonth() + 1).toString().padStart(2, '0');
					let date = dt.getDate().toString().padStart(2, '0');
					return `${year}-${month}-${date}`;
				} else {// yyyy-MM-dd HH:mm:ss
					let year = dt.getFullYear();
					let month = (dt.getMonth() + 1).toString().padStart(2, '0');
					let date = dt.getDate().toString().padStart(2, '0');
					let hour = dt.getHours().toString().padStart(2, '0');
					let minute = dt.getMinutes().toString().padStart(2, '0');
					let second = dt.getSeconds().toString().padStart(2, '0');
					return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
				}
			}
		},
		methods: {
			goBack() {
				this.$router.push({
					name: 'workbench'
				});
			},
			toAdd(){
				this.$router.push({
					name: 'qualityPatrolAdd',
				});
			},
			goEdit(id){
				this.$router.push({
					name: 'qualityPatrolEdit',
					query: {"id": id}
				});
			},
			goDetail(id){
				if (!common.hasPermision("patrol:look:1")) {
					return;
				}
				this.$router.push({
					name: 'qualityPatrolDetail',
					query: {"id": id}
				});
			},
			goClose(id){
				this.$router.push({
					name: 'qualityPatrolClose',
					query: {"id": id}
				});
			},
			onRefresh(){
				this.finished = false;
				this.loading = true;
				this.queryParam.page = 1;
				this.dataList = [];
				this.onLoad();
			},
			onClear(){
				this.keyWord = '';
			},
			loadMore(){
				this.queryParam.page += 1;//页数+1
      			this.onLoad();
			},
			onLoad(){
				if (this.isRefreshLoading){
					this.queryParam.page = 1;
					this.dataList = [];
					this.isRefreshLoading = false;
				}
				list(this.queryParam).then(response => {
					this.loading = false
					if (response.data.resultCode === 200){
						// 检索结果明细
						this.dataList = this.dataList.concat(response.data.body.records);
						if (response.data.body.records.length === 0) {
							this.finished = true;
						}
					}else{
						this.finished = true;
					}
				})
			},
			selStatusPicker(data){
				this.queryParam.closeState = data.id
				this.onRefresh()
				this.showStatusPicker = false;
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
<style lang="scss" scoped>
	.div_icon {
        text-align: right;
		vertical-align: middle;
		background-color: #ffffff;
        line-height: 54px;
    }
</style>